import React from "react";
import Head from "next/head";

export interface SeoInterface {
  title?: string;
  description?: string;
  image?: string;
  article?: boolean;
}

const Seo = ({ seo = {} }: { seo: SeoInterface }) => {
  //   const { defaultSeo, siteName, favicon } = strapiGlobal;

  const siteName = "Bodycam Report";

  const defaultSeo = {
    title: "",
    description: "",
    image: "",
    article: "",
  };

  // Merge default and page-specific SEO values
  const fullSeo = { ...defaultSeo, ...seo };

  const favicon = "";

  const getMetaTags = () => {
    const tags = [];

    if (fullSeo.title) {
      tags.push(
        {
          property: "og:title",
          content: fullSeo.title,
        },
        {
          name: "twitter:title",
          content: fullSeo.title,
        }
      );
    }

    if (fullSeo.description) {
      tags.push(
        {
          name: "description",
          content: fullSeo.description,
        },
        {
          property: "og:description",
          content: fullSeo.description,
        },
        {
          name: "twitter:description",
          content: fullSeo.description,
        }
      );
    }

    if (fullSeo.image) {
      tags.push(
        {
          name: "image",
          content: fullSeo.image,
        },
        {
          property: "og:image",
          content: fullSeo.image,
        },
        {
          name: "twitter:image",
          content: fullSeo.image,
        }
      );
    }

    tags.push({ name: "twitter:card", content: "summary_large_image" });

    return tags;
  };

  const metaTags = getMetaTags();

  return (
    <Head>
      <title>
        {fullSeo.title} | {siteName}
      </title>
      {metaTags.map((tag) => (
        <meta key={tag.name} property={tag.name} content={tag.content} />
      ))}
    </Head>
  );
};

export default Seo;
